import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import './activitesExterieures.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const ActivitesExterieures = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="activ-page">
      <Helmet>
        <title>Activités extérieures | Le Hameau du Sorbier</title>
        <meta
          name="description"
          content="Idées de visites, sites incontournables et activités autour du Hameau du Sorbier."
        />
      </Helmet>




      <section className="activ-section bg-dordogne" data-aos="fade-up">
        <div className="section-inner">
          <h1> Découvrir les alentours</h1>
          <p className="section-intro">Patrimoine, nature et découvertes à proximité du Hameau du Sorbier.</p>

        </div>
      </section>


      {/* VILLAGES À VISITER */}
      <section className="activ-section bg-white section-villages" data-aos="fade-up">
        <div className="section-inner">
          <h2>Villages à visiter</h2>
          <p className="section-intro">
            Découvrez les plus beaux villages du Périgord, tous à moins d’une heure du hameau :
          </p>

          <div className="villages-grid">
            <a href="https://www.sarlat-tourisme.com/" target="_blank" rel="noreferrer">Sarlat-la-Canéda</a>
            <a href="https://www.saintgenies.com//" target="_blank" rel="noreferrer">Saint-Geniès</a>
            <a href="https://www.saintamanddecoly.fr/" target="_blank" rel="noreferrer">Saint-Amand de Coly</a>
            <a href="https://www.les-plus-beaux-villages-de-france.org/fr/nos-villages/saint-leon-sur-vezere/" target="_blank" rel="noreferrer">Saint-Léon-sur-Vézère</a>
            <a href="https://www.laroquegageac.fr/" target="_blank" rel="noreferrer">La Roque-Gageac</a>
            <a href="https://www.ville-terrasson.fr/" target="_blank" rel="noreferrer">Terrasson-Lavilledieu</a>
            <a href="https://www.vallee-dordogne.com/la-vallee-de-la-dordogne/villes-et-villages/collonges-la-rouge" target="_blank" rel="noreferrer">Collonges-la-Rouge</a>
            <a href="https://www.vallee-dordogne.com/rocamadour" target="_blank" rel="noreferrer">Rocamadour </a>
          </div>
        </div>
      </section>


      {/* JARDINS REMARQUABLES */}
     <section className="activ-section bg-jardins" data-aos="fade-up">
      <div className="section-inner">
        <h2>Jardins remarquables</h2>
        <p className="section-intro">Trois jardins d’exception à ne pas manquer dans le Périgord Noir.</p>

        <div className="ext-grid">
          <article className="ext-card image-card">
            <img src="/img/exterieur/jardin-erygnac.jpg" alt="Eyrignac et ses jardins" />
            <div>
              <h3>Eyrignac et ses jardins</h3>
              <p>Salignac-Eyvigues — Jardin à la française exceptionnel.</p>
              <a href="https://www.eyrignac.com/fr" target="_blank" rel="noreferrer">
                Voir le site
              </a>
            </div>
          </article>

          <article className="ext-card image-card">
            <img src="/img/exterieur/jardin-imaginaire.webp" alt="Jardins de l’Imaginaire" />
            <div>
              <h3>Les Jardins de l’Imaginaire</h3>
              <p>Terrasson — promenade poétique entre art et nature.</p>
              <a href="https://www.jardins-imaginaire.com/" target="_blank" rel="noreferrer">
                Voir le site
              </a>
            </div>
          </article>

          <article className="ext-card image-card">
            <img src="/img/exterieur/jardin-marqueyssac.jpg" alt="Jardins de Marqueyssac" />
            <div>
              <h3>Les Jardins suspendus de Marqueyssac</h3>
              <p>Vézac — panorama à couper le souffle sur la Dordogne.</p>
              <a href="https://www.marqueyssac.com/" target="_blank" rel="noreferrer">
                Voir le site
              </a>
            </div>
          </article>

          {/* Nouveau jardin */}
          <article className="ext-card image-card">
            <img src="/img/exterieur/jardin-limeuil.jpg" alt="Jardins panoramiques de Limeuil" />
            <div>
              <h3>Les Jardins panoramiques de Limeuil</h3>
              <p>Limeuil — rencontre entre botanique, histoire et paysages.</p>
              <a href="https://www.jardins-panoramiques-limeuil.com/" target="_blank" rel="noreferrer">
                Voir le site
              </a>
            </div>
          </article>
        </div>
      </div>
    </section>


      {/* PRÉHISTOIRE & SITES TROGLODYTIQUES */}
    <section className="activ-section bg-lightbrown" data-aos="fade-up">
      <div className="section-inner">
        <h2>Préhistoire & sites troglodytiques</h2>
        <p className="section-intro">
          Une plongée fascinante dans les origines de l’humanité, au cœur de la vallée de la Vézère.
        </p>

        <div className="ext-grid ext-grid--pyramid">
          <article className="ext-card image-card">
            <img src="/img/exterieur/lascaux.webp" alt="Lascaux" />
            <div>
              <h3>Grottes de Lascaux</h3>
              <p>Montignac — site emblématique de la préhistoire mondiale.</p>
              <a href="https://lascaux.fr/fr/" target="_blank" rel="noreferrer">
                Voir le site
              </a>
            </div>
          </article>

          <article className="ext-card image-card">
            <img src="/img/exterieur/conquil.jpg" alt="Le Conquil" />
            <div>
              <h3>Le Conquil – site troglodytique</h3>
              <p>Saint-Léon-sur-Vézère — habitats troglos & accrobranche.</p>
              <a href="https://leconquil.fr/" target="_blank" rel="noreferrer">
                Voir le site
              </a>
            </div>
          </article>

          <article className="ext-card image-card">
            <img src="/img/exterieur/village-de-la-madeleine.jpg" alt="La Madeleine" />
            <div>
              <h3>Village de la Madeleine</h3>
              <p>Tursac — site troglodytique en falaise, cadre unique.</p>
              <a href="https://la-madeleine-perigord.com/" target="_blank" rel="noreferrer">
                Voir le site
              </a>
            </div>
          </article>


          <article className="ext-card image-card">
            <img src="/img/exterieur/gouffre-padirac.webp" alt="Gouffre de Padirac" />
            <div>
              <h3>Gouffre de Padirac</h3>
              <p>Padirac — cathédrale souterraine et rivière à 103 mètres de profondeur.</p>
              <a href="https://www.gouffre-de-padirac.com//" target="_blank" rel="noreferrer">
                Voir le site
              </a>
            </div>
          </article>

          <article className="ext-card image-card">
            <img src="/img/exterieur/gouffre-proumeyssac.jpg" alt="Gouffre de Proumeyssac" />
            <div>
              <h3>Gouffre de Proumeyssac</h3>
              <p>Audrix — plus grande cavité aménagée du Périgord, appelée « Cathédrale de Cristal ».</p>
              <a href="https://www.gouffre-proumeyssac.com/" target="_blank" rel="noreferrer">
                Voir le site
              </a>
            </div>
          </article>
        </div>
      </div>
    </section>


      {/* CHÂTEAUX & PATRIMOINE */}
      <section className="activ-section bg-chateaux" data-aos="fade-up">
        <div className="section-inner">
          <h2>Châteaux & patrimoine</h2>
          <p className="section-intro">Les forteresses et demeures emblématiques du Périgord Noir.</p>

          <div className="ext-grid">
            <article className="ext-card image-card">
              <img src="/img/exterieur/chateau-hautefort.webp" alt="Château de Hautefort" />
              <div>
                <h3>Château de Hautefort</h3>
                <a href="https://www.chateau-hautefort.com/" target="_blank" rel="noreferrer">Voir le site</a>
              </div>
            </article>

            <article className="ext-card image-card">
              <img src="/img/exterieur/chateau-milandes.jpg" alt="Château des Milandes" />
              <div>
                <h3>Château des Milandes</h3>
                <a href="https://www.milandes.com/" target="_blank" rel="noreferrer">Voir le site</a>
              </div>
            </article>

            <article className="ext-card image-card">
              <img src="/img/exterieur/chateau-castelnaud.jpg" alt="Château de Castelnaud" />
              <div>
                <h3>Château de Castelnaud</h3>
                <a href="https://castelnaud.com/" target="_blank" rel="noreferrer">Voir le site</a>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* PARCS & LOISIRS */}
      <section className="activ-section bg-terracotta-light" data-aos="fade-up">
        <div className="section-inner">
          <h2>Parcs & activités familiales</h2>
          <p className="section-intro">Des sorties nature et ludiques à partager en famille.</p>

          <div className="ext-grid">
            <article className="ext-card image-card">
              <img src="/img/exterieur/foret-mysterieuse2.jpg" alt="La Forêt Mystérieuse" />
              <div>
                <h3>La Forêt mystérieuse</h3>
                <p>Saint-Geniès — balade féérique dans la forêt.</p>
                <a href="https://laforetmysterieuse.com/" target="_blank" rel="noreferrer">Voir le site</a>
              </div>
            </article>

            <article className="ext-card image-card">
              <img src="/img/exterieur/thot.webp" alt="Parc du Thot" />
              <div>
                <h3>Parc du Thot</h3>
                <p>Thonac — découverte de la préhistoire et des animaux d’époque.</p>
                <a href="https://parc-thot.fr/fr/" target="_blank" rel="noreferrer">Voir le site</a>
              </div>
            </article>

            <article className="ext-card image-card">
              <img src="/img/exterieur/bournat.jpg" alt="Parc du Bournat" />
              <div>
                <h3>Le Bournat</h3>
                <p>Bugue — reconstitution d’un village périgourdin des années 1900.</p>
                <a href="https://www.parclebournat.fr/fr/" target="_blank" rel="noreferrer">Voir le site</a>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* ACTIVITÉS SPORTIVES */}
      <section className="activ-section bg-beige section-sport" data-aos="fade-up">
        <div className="section-inner">
          <h2>Activités sportives & plein air</h2>
          <p className="section-intro">
            Le Périgord Noir offre de nombreuses possibilités pour les amoureux de la nature et du grand air.
          </p>

          {/* Bloc 1 : Canoës */}
          <div className="sport-block">
            <div className="sport-text">
              <h3>Canoës & balades</h3>
              <p>
                Descente en canoë sur la <strong>Dordogne</strong> ou la <strong>Vézère</strong> 
                (Montignac, Vézac, Saint-Léon-sur-Vézère, etc.), randonnées, escalade, VTT ou spéléologie : 
                les alentours du Hameau du Sorbier regorgent d’activités en pleine nature.
              </p>
            </div>
            <div className="sport-image">
              <img src="/img/exterieur/canoe.jpg" alt="Canoë sur la Dordogne" />
            </div>
          </div>

          {/* Bloc 2 : Marchés */}
          <div className="sport-block reverse">
            <div className="sport-text">
              <h3>Marchés locaux</h3>
              <p>
                Découvrez les marchés typiques du Périgord : produits du terroir, artisans locaux 
                et ambiance conviviale vous attendent toute l’année.
              </p>
            </div>
            <div className="sport-image">
              <img src="/img/exterieur/marche.png" alt="Marché du Périgord" />
            </div>
          </div>
        </div>
      </section>


    </div>
  );
};

export default ActivitesExterieures;
